export const setTickets = (tickets) => ({
    type: 'SET_TICKETS',
    payload: tickets
});

export const setUsuarios = (usuarios) => ({
    type: 'SET_USUARIOS',
    payload: usuarios
});